<!-- Free Form Style Form -->
@if (freeFormStyleForm) {
  <medsurf-design-form-control-form
    [formGroup]="freeFormStyleForm"
    [class]="'w-full'"
    (onSubmit)="onSubmit()">
    <div class="flex flex-column row-gap-2 align-items-center">
      <h4 class="uppercase align-self-start"
        translate="global.points">
      </h4>
      <!-- Start Type -->
      <medsurf-design-form-control-input-dropdown [control]="freeFormStyleForm.controls.startType"
        [class]="'w-full'"
        [options]="FlatModels.AnnotationEntityModels.TipTypeArray"
        [label]="'global.start'"
      (valueChange)="onStartTypeChange()"></medsurf-design-form-control-input-dropdown>
      <!-- Start Radius -->
      <medsurf-design-form-control-input-slider [hidden]="freeFormStyleForm.value.startType !== FlatModels.AnnotationEntityModels.TipType.enum.circle"
        [control]="freeFormStyleForm.controls.startRadius"
        [class]="'w-full'"
        [min]="1"
        [max]="100"
        [label]="'global.circle_radius'"
      (valueChange)="onSubmit()"></medsurf-design-form-control-input-slider>
      <!-- End Type -->
      <medsurf-design-form-control-input-dropdown [control]="freeFormStyleForm.controls.endType"
        [class]="'w-full'"
        [options]="FlatModels.AnnotationEntityModels.TipTypeArray"
        [label]="'global.end'"
      (valueChange)="onEndTypeChange()"></medsurf-design-form-control-input-dropdown>
      <!-- End Radius -->
      <medsurf-design-form-control-input-slider [hidden]="freeFormStyleForm.value.endType !== FlatModels.AnnotationEntityModels.TipType.enum.circle"
        [control]="freeFormStyleForm.controls.endRadius"
        [class]="'w-full'"
        [min]="1"
        [max]="100"
        [label]="'global.circle_radius'"
      (valueChange)="onSubmit()"></medsurf-design-form-control-input-slider>
    </div>
  </medsurf-design-form-control-form>
}